export default {
  meta: {
    title: '编辑审核'
  }
};
